module.exports = __webpack_public_path__ + "static/media/r4.5150d1ec.jpg";